export const LOGIN_IDENTIFIER = 'hx_login_identifier'
